import React, { FC } from 'react';
import { CircularProgress } from '@mui/material';
import { Close, DoneAll } from '@mui/icons-material';
import clsx from 'clsx';

import { AnimatedButton } from '../../common';
import './ApproveDismissBar.scss';

interface ApproveDismissBarProps {
  onApproveAll: () => void;
  onDismissAll: () => void;
  approveLabel: string;
  /** Not shown as text — used for the close button's accessibility label. */
  dismissLabel?: string;
  disabled?: boolean;
  loading?: boolean;
  compact?: boolean;
}

/**
 * Shared "Dismiss All" (close-icon button) / "Approve All" (solid pill)
 * action bar, used both by the grouped suggested-blocks list and the insight
 * card's chip row.
 */
const ApproveDismissBar: FC<ApproveDismissBarProps> = ({
  onApproveAll,
  onDismissAll,
  approveLabel,
  dismissLabel = 'Dismiss all',
  disabled = false,
  loading = false,
  compact = false,
}) => (
  <div className="approve-dismiss-bar">
    <AnimatedButton
      onPress={onDismissAll}
      disabled={disabled}
      fullWidth={false}
      className="approve-dismiss-bar__dismiss-button"
      ariaLabel={dismissLabel}
    >
      <Close fontSize="small" className="approve-dismiss-bar__dismiss-icon" />
    </AnimatedButton>
    <AnimatedButton
      onPress={onApproveAll}
      disabled={disabled}
      wrapperStyle={{ flex: 1 }}
      className={clsx('approve-dismiss-bar__approve-button', {
        'approve-dismiss-bar__approve-button--compact': compact,
      })}
    >
      {loading ? (
        <CircularProgress size={16} className="approve-dismiss-bar__approve-spinner" />
      ) : (
        <>
          <DoneAll fontSize="small" className="approve-dismiss-bar__approve-icon" />
          <span className="approve-dismiss-bar__approve-text">{approveLabel}</span>
        </>
      )}
    </AnimatedButton>
  </div>
);

export default ApproveDismissBar;
